import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resCreateResearch {
  message: string,
  result: {
    RESEARCH_ID: string,
  }
  success: boolean
}

interface resGetAllResearch {
  message: string,
  result: [
    {
      ALWAYS_OPEN: string,
      COIN: number,
      COIN_SHARE: number,
      CONSENT: string,
      CREATE_BY: string,
      CREATE_DATE: Date,
      CREATE_NAME: string,
      DOC_ORIGINAL: string,
      IMAGE_ORIGANAL: string,
      MEASURES: [string],
      RESEARCH_DETAIL: string,
      RESEARCH_DOC: string,
      RESEARCH_END: Date,
      RESEARCH_ID: string,
      RESEARCH_IMG: string,
      RESEARCH_NAME: string,
      RESEARCH_START: Date,
      STATUS_RESEARCH: string,
      UPDATE_DATE: Date,
      VALUE: string,
    }
  ]
  success: boolean
}

interface resGetDetailResearchById {
  message: string,
  result: [
    {
      ALWAYS_OPEN: string,
      COIN: number,
      COIN_SHARE: number,
      CONSENT: string,
      CREATE_BY: string,
      CREATE_DATE: Date,
      DOC_ORIGINAL: string,
      IMAGE_ORIGANAL: string,
      RESEARCH_DETAIL: string,
      RESEARCH_DOC: string,
      RESEARCH_END: Date,
      RESEARCH_ID: string,
      RESEARCH_IMG: string,
      RESEARCH_NAME: string,
      RESEARCH_START: Date,
      STATUS_RESEARCH: number,
      UPDATE_DATE: Date,
      VALUE: string,
    }
  ]
  success: boolean
}

interface resDelResearchById {
  message: string,
  result: {
    update: Date,
  }
  success: boolean
}

interface resExportResearchById {
  message: string,
  result: [{
    DATAS: [Object],
    DATA_SCRENE: Object,
    RESEARCH_NAME: Date,
    USER_ID: string,
  }]
  success: boolean
}

@Injectable({
  providedIn: 'root'
})
export class ResearchManagementService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  createResearch(form) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let formData = new FormData;

    // console.log(form);

    if (form.researchDocument) {
      formData.append('RESEARCH_DOC', form.researchDocument);
    }
    if (form.researchImg) {
      formData.append('RESEARCH_IMG', form.researchImg);
    }

    if (form.alwaysOpen) {
      formData.append('RESEARCH_START', new Date().toDateString().slice(0, 10));
      formData.append('RESEARCH_END', new Date().toDateString().slice(0, 10));
      formData.append('ALWAYS_OPEN', 'true');
    } else {
      formData.append('RESEARCH_START', form.date[0].toLocaleString().slice(0, 10));
      formData.append('RESEARCH_END', form.date[1].toLocaleString().slice(0, 10));
      formData.append('ALWAYS_OPEN', 'false');
    }

    const value = {
      measureOftraget: form.target,
      measureOfresearch: form.measures
    }

    formData.append('RESEARCH_NAME', form.name);
    formData.append('CONSENT', form.consent);
    formData.append('RESEARCH_DETAIL', form.detail);
    formData.append('COIN', form.coin);
    formData.append('COIN_SHARE', form.coinShare);
    formData.append('VALUE', JSON.stringify(value));

    return this.http.post<resCreateResearch>(environment.URL + '/manage_admin/createResearch', formData, { headers: headers });
  }

  editResearchById(form, data) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let formData = new FormData;
    // // console.log(form);
    // // console.log(data);

    if (data.docEdit && form.researchDocument) {
      // console.log('doc edit');
      formData.append('RESEARCH_DOC', form.researchDocument);
    }
    if (data.imgEdit && form.researchImg) {
      // console.log('img edit');
      formData.append('RESEARCH_IMG', form.researchImg);
    }

    if (form.alwaysOpen) {
      formData.append('RESEARCH_START', new Date().toDateString().slice(0, 10));
      formData.append('RESEARCH_END', new Date().toDateString().slice(0, 10));
      formData.append('ALWAYS_OPEN', 'true');
    } else {
      formData.append('RESEARCH_START', new Date(form.date[0]).toLocaleString().slice(0, 10));
      formData.append('RESEARCH_END', new Date(form.date[1]).toLocaleString().slice(0, 10));
      formData.append('ALWAYS_OPEN', 'false');
    }

    const value = {
      measureOftraget: form.target,
      measureOfresearch: form.measures
    }

    formData.append('RESEARCH_ID', data.id);
    formData.append('RESEARCH_NAME', form.name);
    formData.append('CONSENT', form.consent);
    formData.append('RESEARCH_DETAIL', form.detail);
    formData.append('COIN', form.coin);
    formData.append('COIN_SHARE', form.coinShare);
    formData.append('VALUE', JSON.stringify(value));
    formData.append('DOC_EDIT', JSON.stringify(data.docEdit));
    formData.append('IMG_EDIT', JSON.stringify(data.imgEdit));

    return this.http.post<resCreateResearch>(environment.URL + '/manage_admin/editResearchById', formData, { headers: headers });
  }

  getAllResearch() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetAllResearch>(environment.URL + '/manage_admin/getAllResearch', { headers: headers });
  }

  getDetailResearchById(id) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetDetailResearchById>(environment.URL + '/manage_admin/getDetailResearchById?RESEARCH_ID=' + id, { headers: headers });
  }

  delResearchById(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resDelResearchById>(environment.URL + '/manage_admin/delResearchById', body, { headers: headers });
  }

  updateStatusViewResearchById(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resDelResearchById>(environment.URL + '/manage_admin/updateStatusViewResearchById', body, { headers: headers });
  }

  exportResearchById(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resExportResearchById>(environment.URL + '/manage_admin/exportResearchById', body, { headers: headers });
  }
}
